import {
  ILabel,
  IRenderContext,
  LabelStyleBase,
  Size,
  SvgVisual,
} from '@ardoq/yfiles';
import { URL_ICON_SIZE } from './consts';
import { renderOpenGroupUrlLabel } from './renderOpenGroupUrlLabel';

class WorkspaceModeOpenGroupUrlLabelStyle extends LabelStyleBase {
  static Instance = new WorkspaceModeOpenGroupUrlLabelStyle();
  private constructor() {
    super();
  }
  override createVisual(context: IRenderContext, label: ILabel) {
    const { layout } = label;
    const container = renderOpenGroupUrlLabel(label);
    LabelStyleBase.createLayoutTransform(context, layout, false).applyTo(
      container
    );
    return new SvgVisual(container);
  }

  override getPreferredSize() {
    return new Size(URL_ICON_SIZE, URL_ICON_SIZE);
  }
}
export { WorkspaceModeOpenGroupUrlLabelStyle };
